import { render, staticRenderFns } from "./PageScreeningHistory.vue?vue&type=template&id=18fe15e7&scoped=true"
import script from "./PageScreeningHistory.vue?vue&type=script&lang=js"
export * from "./PageScreeningHistory.vue?vue&type=script&lang=js"
import style0 from "./PageScreeningHistory.vue?vue&type=style&index=0&id=18fe15e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe15e7",
  null
  
)

export default component.exports